import React from 'react';

import Code from '@atlaskit/code/code';
import { Text } from '@atlaskit/primitives/compiled/text';
import { Table } from '@atlaskit/table/primitives/table';
import { TBody } from '@atlaskit/table/primitives/tbody';
import { TH } from '@atlaskit/table/primitives/th';
import { THead } from '@atlaskit/table/primitives/thead';
import { TR } from '@atlaskit/table/primitives/tr';
import { Cell as TD } from '@atlaskit/table/td';

import HorizontalScrollContainer from '../horizontal-scroll-container';
import { values } from './values';

/**
 * __Radius focus table__
 */
export const RadiusFocusTable = (): React.JSX.Element => {
	return (
		<HorizontalScrollContainer>
			<Table testId="radius-focus-table">
				<THead>
					<TR isBodyRow={false}>
						<TH width="150px">Element radius token</TH>
						<TH width="150px">Focus radius token to pair with</TH>
						<TH width="150px">Focus ring radius value*</TH>
					</TR>
				</THead>
				<TBody>
					{values.map((token) => {
						return (
							!['radius.full', 'radius.tile'].includes(token.tokenName) && (
								<TR key={token.tokenName}>
									<TD>
										<Code>{token.tokenName}</Code>
									</TD>
									<TD>
										<Code>{token.focusTokenName}</Code>
									</TD>
									<TD>
										<Text>{token.focusRingRadiusValue}</Text>
									</TD>
								</TR>
							)
						);
					})}
				</TBody>
			</Table>
		</HorizontalScrollContainer>
	);
};
